// extracted by mini-css-extract-plugin
export default {"container":"callback_container__DjzTv","content":"callback_content__By+b4","loading":"callback_loading__Usb9N","title":"callback_title__eZEke"};